import { createFileRoute } from '@tanstack/react-router';
import { CandidateImportRequestsPresetEditTemplate } from '@/features/agent/candidate_import_requests/templates/CandidateImportRequestsPresetEditTemplate';

export const Route = createFileRoute(
  '/agent/candidates/candidate_import_requests/presets/$presetId/'
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <CandidateImportRequestsPresetEditTemplate />;
}
